// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-Q":"Q_dpu-detail-Q__lef_2"};